import { __exportAll } from "../_virtual/_rolldown/runtime.js";
import { DonationRoundUpPromptType, IntegrationSystem } from "@biteinc/enums";
import { I9nSchemaBySystem } from "@biteinc/common";
//#region src/helpers/base_integration_helper.ts
var base_integration_helper_exports = /* @__PURE__ */ __exportAll({
	canLookUpOrderHistoryOnLoyalty: () => canLookUpOrderHistoryOnLoyalty,
	canSendOrderWithoutAuth: () => canSendOrderWithoutAuth,
	getDonationRoundUpPromptType: () => getDonationRoundUpPromptType,
	getEbtAcceptanceFields: () => getEbtAcceptanceFields,
	getFrontendUrl: () => getFrontendUrl,
	getMemoItem: () => getMemoItem,
	getMemoItemId: () => getMemoItemId,
	getPaymentI9nProcessor: () => getPaymentI9nProcessor,
	hasPreReadEnabled: () => hasPreReadEnabled,
	holdsOrdersUntilPosPaymentNotification: () => holdsOrdersUntilPosPaymentNotification,
	loyaltyPaymentEnabled: () => loyaltyPaymentEnabled,
	sendsPosOriginatedOrdersToFulfillment: () => sendsPosOriginatedOrdersToFulfillment,
	usesI9nIdFallback: () => usesI9nIdFallback,
	usesMemoItem: () => usesMemoItem,
	usesOnPremConnection: () => usesOnPremConnection
});
function canLookUpOrderHistoryOnLoyalty(data) {
	const schema = I9nSchemaBySystem[data.system];
	if (schema.type !== "loyalty") return false;
	switch (schema.system) {
		case IntegrationSystem.CheetahOloLoyalty:
		case IntegrationSystem.ComoOlo:
		case IntegrationSystem.OloAccountsLoyalty:
		case IntegrationSystem.PaytronixOlo:
		case IntegrationSystem.PeetsPaytronixOlo:
		case IntegrationSystem.PinataLoyalty:
		case IntegrationSystem.PunchhOlo:
		case IntegrationSystem.SessionMOlo:
		case IntegrationSystem.SpendgoOlo:
		case IntegrationSystem.ThanxOlo:
			if (schema.system !== data.system) throw new Error(`i9n system mismatch: expected ${schema.system}, got ${data.system}`);
			return !!data.lookupOrderHistoryOnLoyalty;
		case IntegrationSystem.Appfront:
		case IntegrationSystem.AtriumLoyalty:
		case IntegrationSystem.ChoptLoyalty:
		case IntegrationSystem.Como:
		case IntegrationSystem.GivexLoyalty:
		case IntegrationSystem.Incentivio:
		case IntegrationSystem.LovesRewards:
		case IntegrationSystem.LoyaltyPlant:
		case IntegrationSystem.Lunchbox:
		case IntegrationSystem.PaytronixLoyalty:
		case IntegrationSystem.Punchh:
		case IntegrationSystem.SmoothCommerce:
		case IntegrationSystem.Sparkfly:
		case IntegrationSystem.Spendgo:
		case IntegrationSystem.StarbucksFullLoyalty:
		case IntegrationSystem.StarbucksPayAndEarnLoyalty:
		case IntegrationSystem.Thanx: return false;
	}
}
function loyaltyPaymentEnabled(data) {
	const schema = I9nSchemaBySystem[data.system];
	if (schema.type !== "loyalty") return false;
	switch (schema.system) {
		case IntegrationSystem.AtriumLoyalty:
		case IntegrationSystem.PinataLoyalty:
		case IntegrationSystem.Punchh:
		case IntegrationSystem.SmoothCommerce:
			if (schema.system !== data.system) throw new Error(`i9n system mismatch: expected ${schema.system}, got ${data.system}`);
			return !!(schema.alwaysUsedAsPayment ?? data.useLoyaltyForPayments);
		case IntegrationSystem.Appfront:
		case IntegrationSystem.CheetahOloLoyalty:
		case IntegrationSystem.ChoptLoyalty:
		case IntegrationSystem.Como:
		case IntegrationSystem.ComoOlo:
		case IntegrationSystem.GivexLoyalty:
		case IntegrationSystem.Incentivio:
		case IntegrationSystem.LovesRewards:
		case IntegrationSystem.LoyaltyPlant:
		case IntegrationSystem.Lunchbox:
		case IntegrationSystem.OloAccountsLoyalty:
		case IntegrationSystem.PaytronixLoyalty:
		case IntegrationSystem.PaytronixOlo:
		case IntegrationSystem.PeetsPaytronixOlo:
		case IntegrationSystem.PunchhOlo:
		case IntegrationSystem.SessionMOlo:
		case IntegrationSystem.Sparkfly:
		case IntegrationSystem.Spendgo:
		case IntegrationSystem.SpendgoOlo:
		case IntegrationSystem.StarbucksFullLoyalty:
		case IntegrationSystem.StarbucksPayAndEarnLoyalty:
		case IntegrationSystem.Thanx:
		case IntegrationSystem.ThanxOlo: return !!schema.alwaysUsedAsPayment;
	}
}
function getEbtAcceptanceFields(data) {
	const defaultEbdAcceptance = {
		enableEbtCashBenefitAcceptance: false,
		enableEbtFoodStampAcceptance: false
	};
	const schema = I9nSchemaBySystem[data.system];
	if (schema.type !== "kiosk-payment") return defaultEbdAcceptance;
	switch (schema.system) {
		case IntegrationSystem.AurusPay:
		case IntegrationSystem.Chase:
		case IntegrationSystem.FreedomPayKiosk:
		case IntegrationSystem.ParPay:
		case IntegrationSystem.PinataPay:
		case IntegrationSystem.PinataPayNative:
		case IntegrationSystem.Worldpay:
			if (schema.system !== data.system) throw new Error(`i9n system mismatch: expected ${schema.system}, got ${data.system}`);
			return {
				enableEbtCashBenefitAcceptance: !!data.enableEbtCashBenefitAcceptance,
				enableEbtFoodStampAcceptance: !!data.enableEbtFoodStampAcceptance
			};
		case IntegrationSystem.Adyen:
		case IntegrationSystem.CardConnect:
		case IntegrationSystem.Eigen:
		case IntegrationSystem.Elavon:
		case IntegrationSystem.Heartland:
		case IntegrationSystem.Moneris:
		case IntegrationSystem.OloPayKioskOrderingApi:
		case IntegrationSystem.OloPayKioskPaymentApi:
		case IntegrationSystem.StripeTerminal:
		case IntegrationSystem.VerifonePointCloud:
		case IntegrationSystem.VerifonePointSca: return defaultEbdAcceptance;
	}
}
function usesMemoItem(system) {
	switch (system) {
		case IntegrationSystem.IQTouch:
		case IntegrationSystem.ParBrink:
		case IntegrationSystem.Simphony:
		case IntegrationSystem.SpotOn: return true;
		default: return false;
	}
}
function getMemoItemId(data) {
	const schema = I9nSchemaBySystem[data.system];
	if (schema.type !== "pos") return null;
	switch (schema.system) {
		case IntegrationSystem.IQTouch:
		case IntegrationSystem.ParBrink:
		case IntegrationSystem.Simphony:
		case IntegrationSystem.SpotOn:
			if (schema.system !== data.system) throw new Error(`i9n system mismatch: expected ${schema.system}, got ${data.system}`);
			return data.memoItemID || null;
		case IntegrationSystem.AramarkActivate:
		case IntegrationSystem.BreadcrumbDeprecated:
		case IntegrationSystem.Deliverect:
		case IntegrationSystem.DeliverectCommerce:
		case IntegrationSystem.Infor:
		case IntegrationSystem.LovesPos:
		case IntegrationSystem.NcrAloha:
		case IntegrationSystem.NcrRadiant:
		case IntegrationSystem.Olo:
		case IntegrationSystem.Omnivore:
		case IntegrationSystem.Otter:
		case IntegrationSystem.PDI:
		case IntegrationSystem.PinataPos:
		case IntegrationSystem.Qu:
		case IntegrationSystem.Revel:
		case IntegrationSystem.Salido:
		case IntegrationSystem.SquarePos:
		case IntegrationSystem.StarbucksPos:
		case IntegrationSystem.Toast:
		case IntegrationSystem.VerifoneCommander: return null;
	}
}
function getMemoItem(data) {
	const schema = I9nSchemaBySystem[data.system];
	if (schema.type !== "pos") return null;
	switch (schema.system) {
		case IntegrationSystem.IQTouch:
		case IntegrationSystem.ParBrink:
		case IntegrationSystem.Simphony:
		case IntegrationSystem.SpotOn:
			if (schema.system !== data.system) throw new Error(`i9n system mismatch: expected ${schema.system}, got ${data.system}`);
			if (!data.memoItemID) return null;
			return data.syncedData?.memoItemById[data.memoItemID] || null;
		case IntegrationSystem.AramarkActivate:
		case IntegrationSystem.BreadcrumbDeprecated:
		case IntegrationSystem.Deliverect:
		case IntegrationSystem.DeliverectCommerce:
		case IntegrationSystem.Infor:
		case IntegrationSystem.LovesPos:
		case IntegrationSystem.NcrAloha:
		case IntegrationSystem.NcrRadiant:
		case IntegrationSystem.Olo:
		case IntegrationSystem.Omnivore:
		case IntegrationSystem.Otter:
		case IntegrationSystem.PDI:
		case IntegrationSystem.PinataPos:
		case IntegrationSystem.Qu:
		case IntegrationSystem.Revel:
		case IntegrationSystem.Salido:
		case IntegrationSystem.SquarePos:
		case IntegrationSystem.StarbucksPos:
		case IntegrationSystem.Toast:
		case IntegrationSystem.VerifoneCommander: return null;
	}
}
function hasPreReadEnabled(data) {
	const schema = I9nSchemaBySystem[data.system];
	if (schema.type !== "kiosk-payment") return false;
	switch (schema.system) {
		case IntegrationSystem.Worldpay:
			if (schema.system !== data.system) throw new Error(`i9n system mismatch: expected ${schema.system}, got ${data.system}`);
			return !!data.enablePreRead;
		case IntegrationSystem.Adyen:
		case IntegrationSystem.AurusPay:
		case IntegrationSystem.CardConnect:
		case IntegrationSystem.Chase:
		case IntegrationSystem.Eigen:
		case IntegrationSystem.Elavon:
		case IntegrationSystem.FreedomPayKiosk:
		case IntegrationSystem.Heartland:
		case IntegrationSystem.Moneris:
		case IntegrationSystem.OloPayKioskOrderingApi:
		case IntegrationSystem.OloPayKioskPaymentApi:
		case IntegrationSystem.ParPay:
		case IntegrationSystem.PinataPay:
		case IntegrationSystem.PinataPayNative:
		case IntegrationSystem.StripeTerminal:
		case IntegrationSystem.VerifonePointCloud:
		case IntegrationSystem.VerifonePointSca: return false;
	}
}
function usesI9nIdFallback(data) {
	const schema = I9nSchemaBySystem[data.system];
	if (schema.type !== "pos") return false;
	switch (schema.system) {
		case IntegrationSystem.Olo:
		case IntegrationSystem.PinataPos:
		case IntegrationSystem.Toast:
			if (schema.system !== data.system) throw new Error(`i9n system mismatch: expected ${schema.system}, got ${data.system}`);
			return !!data.shouldUseI9nIdFallback;
		case IntegrationSystem.AramarkActivate:
		case IntegrationSystem.BreadcrumbDeprecated:
		case IntegrationSystem.Deliverect:
		case IntegrationSystem.DeliverectCommerce:
		case IntegrationSystem.Infor:
		case IntegrationSystem.IQTouch:
		case IntegrationSystem.LovesPos:
		case IntegrationSystem.NcrAloha:
		case IntegrationSystem.NcrRadiant:
		case IntegrationSystem.Omnivore:
		case IntegrationSystem.Otter:
		case IntegrationSystem.ParBrink:
		case IntegrationSystem.PDI:
		case IntegrationSystem.Qu:
		case IntegrationSystem.Revel:
		case IntegrationSystem.Salido:
		case IntegrationSystem.Simphony:
		case IntegrationSystem.SpotOn:
		case IntegrationSystem.SquarePos:
		case IntegrationSystem.StarbucksPos:
		case IntegrationSystem.VerifoneCommander: return false;
	}
}
function usesOnPremConnection(data) {
	switch (data.system) {
		case IntegrationSystem.FreshKDS: return !!data.freshKdsUseOnPremConnection;
		case IntegrationSystem.LogicControls: return !!data.logicControlsUseOnPremConnection;
		default: return false;
	}
}
function holdsOrdersUntilPosPaymentNotification(data) {
	switch (data.system) {
		case IntegrationSystem.LogicControls:
		case IntegrationSystem.PinataFulfillment: return !!data.holdOrdersUntilPosPaymentNotification;
		default: return false;
	}
}
function sendsPosOriginatedOrdersToFulfillment(data) {
	switch (data.system) {
		case IntegrationSystem.LogicControls:
		case IntegrationSystem.PinataFulfillment: return !!data.sendPosOriginatedOrdersToFulfillment;
		default: return false;
	}
}
function getPaymentI9nProcessor(data) {
	switch (data?.system) {
		case IntegrationSystem.Eigen: return data.processor;
		default: return null;
	}
}
function getFrontendUrl(data) {
	switch (data.system) {
		case IntegrationSystem.Simphony: return data.frontendUrl || null;
		default: return null;
	}
}
function getDonationRoundUpPromptType(data) {
	switch (data.system) {
		case IntegrationSystem.Olo:
		case IntegrationSystem.PinataPos: return data.promptForDonationRoundUp || DonationRoundUpPromptType.None;
		case IntegrationSystem.IQTouch:
		case IntegrationSystem.ParBrink: return !!data.promptForDonationRoundUp && !!data.donationItemId ? data.promptForDonationRoundUp : DonationRoundUpPromptType.None;
		case IntegrationSystem.Toast: return !!data.promptForDonationRoundUp && !!data.donationServiceChargeID ? data.promptForDonationRoundUp : DonationRoundUpPromptType.None;
		default: return DonationRoundUpPromptType.None;
	}
}
function canSendOrderWithoutAuth(data) {
	switch (data.system) {
		case IntegrationSystem.Como:
		case IntegrationSystem.LoyaltyPlant:
		case IntegrationSystem.PaytronixLoyalty:
		case IntegrationSystem.PaytronixOlo:
		case IntegrationSystem.PeetsPaytronixOlo:
		case IntegrationSystem.Punchh:
		case IntegrationSystem.PunchhOlo: return !!data.sendOrderWithoutAuth;
		case IntegrationSystem.Appfront:
		case IntegrationSystem.AtriumLoyalty:
		case IntegrationSystem.CheetahOloLoyalty:
		case IntegrationSystem.ChoptLoyalty:
		case IntegrationSystem.ComoOlo:
		case IntegrationSystem.GivexLoyalty:
		case IntegrationSystem.Incentivio:
		case IntegrationSystem.LovesRewards:
		case IntegrationSystem.Lunchbox:
		case IntegrationSystem.OloAccountsLoyalty:
		case IntegrationSystem.PinataLoyalty:
		case IntegrationSystem.SessionMOlo:
		case IntegrationSystem.SmoothCommerce:
		case IntegrationSystem.Sparkfly:
		case IntegrationSystem.Spendgo:
		case IntegrationSystem.SpendgoOlo:
		case IntegrationSystem.StarbucksFullLoyalty:
		case IntegrationSystem.StarbucksPayAndEarnLoyalty:
		case IntegrationSystem.Thanx:
		case IntegrationSystem.ThanxOlo: return !!I9nSchemaBySystem[data.system].sendOrderWithoutAuth;
	}
}
//#endregion
export { base_integration_helper_exports, canLookUpOrderHistoryOnLoyalty, canSendOrderWithoutAuth, getDonationRoundUpPromptType, getEbtAcceptanceFields, getFrontendUrl, getMemoItem, getMemoItemId, getPaymentI9nProcessor, hasPreReadEnabled, holdsOrdersUntilPosPaymentNotification, loyaltyPaymentEnabled, sendsPosOriginatedOrdersToFulfillment, usesI9nIdFallback, usesMemoItem, usesOnPremConnection };

//# sourceMappingURL=base_integration_helper.js.map